import React, { useState, useEffect } from "react";
import axios from "axios";
import "./OrganizacionaSema.css";
import { useGlobalContext } from "../../../../../Context/Context";
import ImageIcon from "../../../../picture/slika.png";

function OrganizacionaSema({ companyId }) {
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const { loggedUser, apiKey } = useGlobalContext();

  const userId = loggedUser.id;

  // 1. Dobavljanje postojeće slike pri učitavanju komponente
  useEffect(() => {
    const fetchSema = async () => {
      try {
        const res = await axios.get(
          `https://data.nadzor.app/api/org_charts/get_org_chart.php?company_id=${companyId}`
        );
        if (res.data.image_path) {
          setImage(`https://data.nadzor.app/${res.data.image_path}`);
        }
      } catch (err) {
        console.error("Greška pri učitavanju šeme", err);
      }
    };
    fetchSema();
  }, [companyId]);

  // 2. Funkcija za Upload
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);
    formData.append("company_id", companyId);
    formData.append("user_id", userId);
    formData.append("api_key", apiKey);

    setLoading(true);
    try {
      const res = await axios.post(
        "https://data.nadzor.app/api/org_charts/upload_org_chart.php",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (res.data.status === 200) {
        // Prikazujemo sliku koristeći putanju koju je vratio server
        setImage(`https://data.nadzor.app/${res.data.image_path}`);
      }
    } catch (err) {
      alert("Upload nije uspeo.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("Da li ste sigurni da želite da obrišete šemu?"))
      return;

    try {
      const res = await axios.post(
        "https://data.nadzor.app/api/org_charts/delete_org_chart.php",
        {
          user_id: userId,
          api_key: apiKey,
          company_id: companyId,
        }
      );

      if (res.data.status === 200) {
        setImage(null);
      } else {
        alert("Greška: " + res.data.message);
      }
    } catch (err) {
      console.error("Server error:", err);
    }
  };

  return (
    <div className="orgSema-container">
      <div className="orgSema-header">
        <h3>ORGANIZACIONA ŠEMA</h3>
        {image && !loading && (
          <button onClick={handleDelete}>OBRIŠI SLIKU</button>
        )}
      </div>

      <div className="orgSema-body">
        {loading ? (
          <div className="loader">Slanje na server...</div>
        ) : image ? (
          <div className="image-preview">
            <img src={image} alt="Organizaciona Šema" />
          </div>
        ) : (
          <label className="upload-frame">
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
            <div className="upload-icon">
              <img src={ImageIcon} alt="Upload Icon" />
            </div>
            <div className="upload-text-main">
              Kliknite kako biste učitali sliku svoje organizacione šeme
            </div>
            <div className="upload-text-sub">
              Podržani formati: PNG, JPG, JPEG
            </div>
          </label>
        )}
      </div>
    </div>
  );
}

export default OrganizacionaSema;
